import { useAppNavigate } from "../../hooks/useAppNavigate";
import React, { useMemo, useState } from "react";
import { Typography } from "@mui/material";
import { Crud } from "../../core/components/crud/Crud";
import { get, list, add, update, deleteUser } from "../../client/api/users";
import { User } from "common/build/prisma/client";
import { createUsersCRUDModel } from "./model";
import { useAuth } from "../../contexts/auth.context";
import { UserType } from "../../models/modelTypes";
import { UserListParameters } from "../../../../common/build/api-parameters/users";
import { AddUser } from "./AddUser";
import { ConfirmDialog } from "../../core/components/ConfirmDialog";

const params = { includeRole: true };
export const UsersScreen = (): JSX.Element => {
    const { goBack } = useAppNavigate();
    const { user: loggedInUser, hasPermission } = useAuth();
    const usersCRUDModel = useMemo(() => createUsersCRUDModel(loggedInUser?.isSchool), [loggedInUser?.isSchool]);
    const [confirmArchive, setConfirmArchive] = useState<{ open: boolean; user: UserType | null }>({
        open: false,
        user: null,
    });

    const handleArchiveClick = (user: UserType) => {
        setConfirmArchive({ open: true, user });
    };

    const handleConfirmArchive = () => {
        if (confirmArchive.user) {
            deleteUser(confirmArchive.user.id).then(() => {
                setConfirmArchive({ open: false, user: null });
                goBack();
            });
        }
    };

    const handleCancelArchive = () => {
        setConfirmArchive({ open: false, user: null });
    };

    return (
        <>
            <Crud<UserType, UserListParameters>
                model={usersCRUDModel}
                noun="User"
                getData={list}
                getItem={get}
                addItem={loggedInUser?.isVerbal ? add : undefined}
                updateItem={hasPermission("UserUpdate") ? update : undefined}
                labelProperty={"name"}
                listParams={params}
                addComponent={AddUser}
                userFilter={true}
                searchable
                actions={[
                    {
                        label: "Archive User",
                        onClick: (_id: number, user: UserType) => {
                            handleArchiveClick(user);
                        },
                        visible: (user: User) => !user.deleted && user.id !== loggedInUser?.id,
                    },
                    {
                        label: "Unarchive User",
                        onClick: (id: number) => {
                            update(id, { deleted: false }).then(() => {
                                goBack();
                            });
                        },
                        visible: (user: User) => user.deleted,
                    },
                ]}
            />
            <ConfirmDialog
                open={confirmArchive.open}
                title="Archive Staff Member"
                confirmButtonText="Archive"
                cancelButtonText="Cancel"
                onConfirm={handleConfirmArchive}
                onCancel={handleCancelArchive}
            >
                <Typography>
                    Are you sure you want to archive{" "}
                    <strong>
                        {confirmArchive.user?.firstName} {confirmArchive.user?.lastName}
                    </strong>
                    ? This action can be undone from the archived users list.
                </Typography>
            </ConfirmDialog>
        </>
    );
};
export default UsersScreen;
